import type React from 'react';
import type { FC } from 'react';

import classNames from 'classnames';

import type { AriaProps } from '@iconik-io/shared-lib/src/react/a11y/aria';

import IconButton from '../../ui/icon_button/icon_button';

import styles from './arrow_opener.module.css';

type Props = {
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  open?: boolean;
  // Row ID used to control the opener state from outside located state class,
  // used in CollapsibleItems.
  id?: string;
  aria?: AriaProps;
};

const ArrowOpener: FC<Props> = (props) => (
  <div className={classNames(styles.root, props.className)}>
    <IconButton
      type="button"
      variant="white"
      iconClassName={classNames(
        styles.icon,
        !props.id
          ? {
              [styles.icon_collapsed]: !props.open,
            }
          : undefined,
      )}
      iconName="chevron_small_isolated_s"
      iconSizeUAD="xs"
      onClick={props.onClick}
      disabled={props.disabled}
      data-expand-target={props.id}
      aria={{
        ...props.aria,
        expanded: props.open,
      }}
    />
  </div>
);

export default ArrowOpener;
